import React from "react";
import { useTranslation } from "react-i18next";
import { SharedEventList } from "./sharedEventList";

/**
 * HSE/KS Observations List - Observations (ISO 9001:2015)
 */
export const HseKsObservationsList = () => {
  const { t } = useTranslation();

  return (
    <SharedEventList
      activeTab="observations"
      title="Observasjoner"
      subtitle="Oversikt over observasjoner (ISO 9001:2015 - kap. 10.2)"
      newButtonLabel={t("Ny observasjon")}
      newButtonPath="/dashboard/hse-ks/events/new?type=observation"
      emptyMessage={t("Ingen observasjoner funnet")}
      searchPlaceholder={t("Søk i observasjoner...")}
      defaultFilters={{
        event_category: "information",
      }}
    />
  );
};

